import {
  StudentExamFilterParams,
  listStudentExams,
} from '@/data/services/studentExamServices';

export const studentExamQueries = {
  all: ['studentExams'] as const,

  list: (filters: StudentExamFilterParams = {}) => ({
    queryKey: [...studentExamQueries.all, 'list', { filters }] as const,
    queryFn: () => listStudentExams(filters),
  }),
};
